module.exports = __webpack_public_path__ + "static/img/fish42.8a8260d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish42.png
// module id = 1x2r
// module chunks = 0